import { AppError } from './app.error';

export class ForbiddenException extends AppError {

    constructor(clazz: string, message?: string, error?: Error) {
        super(clazz, message, error);
        this.stack = error?.stack;
    }
}